module.exports = __webpack_public_path__ + "chip_white.46e06e78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/landing/white/chip_white.png
// module id = 936
// module chunks = 0